// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"7dcdd844","255":"937e9971","339":"805931fa","640":"b1b7fcae"}[chunkId] + ".chunk.js";
};